
import CalPara from "~/components/cal-para.vue";
import CalCenterHeading from "~/components/cal-center-heading.vue";
import SignupPopup from "~/components/cal-signup-pop.vue";
export default {
  components: { CalPara, CalCenterHeading, SignupPopup },
  name: "cal-sign-up",
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        errMessageFirstName: "",
      },
      signupAlertDialog: false,
      showAlert: false,
      alertMessage: "",
    };
  },
  methods: {
    isEmailValid(email) {
      const regex =
        /^(?=^.{8,}$)[-_A-Za-z0-9]+([_.-][a-zA-Z0-9]+)*@[A-Za-z0-9]+([.-][a-zA-Z0-9]+)*\.[A-Za-z]{2,}$/;
      return regex.test(email);
    },
    isFormValid() {
      if (
        this.form.firstName &&
        this.form.lastName &&
        this.form.email &&
        this.form.password
      )
        return true;
    },
    async signUp() {
      try {
        let userSignUpCread = {
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          email: this.form.email.toLowerCase(),
          password: this.form.password,
        };
        let user = await this.$store.dispatch(
          "account/SIGN_UP",
          userSignUpCread
        );
        this.signupAlertDialog = true;
      } catch (error) {
        if (error.message.includes("UserLambdaValidationException")) {
          this.showAlert = true;
          this.alertMessage =
            this.$t("alert_message_existing_user_before") +
            ` ${this.form.email} ` +
            this.$t("alert_message_existing_user_after");
          console.log(
            `User with email address ${this.form.email} already exists `
          );
        } else if (
          error.message.includes("InvalidPasswordException") ||
          error.message.includes("InvalidParameterException")
        ) {
          console.log(error.message);
          this.showAlert = true;
          this.alertMessage = this.$t("unsatisfying_password");
          console.log(`Password failed to satisfy`);
        } else {
          this.showAlert = true;
          this.alertMessage = this.$t("alert_message_signup_error");
          console.log("error signing up:", error);
        }
      }
    },
    closeSignupAlertDialog() {
      this.form.firstName = "";
      this.form.lastName = "";
      this.form.email = "";
      this.form.password = "";
      this.signupAlertDialog = false;
    },
  },
};
